import { Controller } from "@hotwired/stimulus"

// Copies a link that is meant to be sent to someone — employees, the OR, a
// kerndeskundige. The button reverts to its own label after a moment, so the
// confirmation does not need a flash message or a live region of its own.
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { copied: String }

  connect() {
    // Without the API there is nothing to click, so only the button goes —
    // the URL itself stays visible and selectable by hand, as before.
    if (!navigator.clipboard && this.hasButtonTarget) this.buttonTarget.hidden = true
  }

  async copy() {
    const text = this.sourceTarget.textContent.trim()
    try {
      await navigator.clipboard.writeText(text)
    } catch {
      return
    }
    const button = this.buttonTarget
    const original = button.textContent
    button.textContent = this.copiedValue || original
    button.setAttribute("aria-live", "polite")
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => { button.textContent = original }, 2000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
